import { useState, useEffect } from "react";

const useLocation = () => {
  const backendApiUrl = process.env.REACT_APP_BACKEND_API;
  const [countryCode, setCountryCode] = useState("in"); // default

  // 1️⃣ Try geolocation
  const getCountryFromLocation = () =>
    new Promise((resolve, reject) => {
      if (!navigator.geolocation) return reject("Geolocation not supported");

      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=en`
          )
            .then((res) => res.json())
            .then((data) => resolve(data?.countryCode?.toLowerCase()))
            .catch(reject);
        },
        reject
      );
    });

  // 2️⃣ IP-based API fallback
  const getCountryFromIP = async () => {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      return data?.country_code?.toLowerCase() || null;
    } catch {
      return null;
    }
  };

  // 3️⃣ Backend API fallback
  const getCountryFromBackend = async () => {
    if (!backendApiUrl) return "in";
    try {
      const res = await fetch(`${backendApiUrl}/api/v1/business/getCountryCodePhoneCode`);
      const { result } = await res.json();
      return result?.countryCode?.toLowerCase() || "in";
    } catch {
      return "in";
    }
  };

  useEffect(() => {
    const detectCountry = async () => {
      try {
        // 1️⃣ Geolocation
        const locCountry = await getCountryFromLocation();
        if (locCountry) {
          setCountryCode(locCountry);
          return;
        }
      } catch {
        // ignore
      }

      try {
        // 2️⃣ IP-based fallback
        const ipCountry = await getCountryFromIP();
        if (ipCountry) {
          setCountryCode(ipCountry);
          return;
        }
      } catch {
        // ignore
      }

      // 3️⃣ Backend fallback
      const backendCountry = await getCountryFromBackend();
      setCountryCode(backendCountry);
    };

    detectCountry();
  }, [backendApiUrl]);

  return { countryCode };
};

export default useLocation;